import { format } from '@polarnopyret/scope';

export default function<T>(property: Scope.Property<T>, args?: { [key: string]: string | number }): T {
  let value = property ? (property as any).$c : null;
  if (typeof value === 'string' && args) {
    value = format(value, args);
  }
  return value;
}
